/** Thin fetch wrapper: same-origin `/api` (Vite proxies to Fastify), cookie session, company header. */
export class ApiError extends Error {
  constructor(public status: number, message: string, public details?: unknown) { super(message); }
}

let currentCompanyId: string | null = null;
export function setCompanyId(id: string | null) { currentCompanyId = id; }
export function getCompanyId() { return currentCompanyId; }

export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.json !== undefined) headers.set('content-type', 'application/json');
  const res = await fetch(path, { ...init, credentials: 'include', headers, body: init.json !== undefined ? JSON.stringify(init.json) : init.body });
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  const data = text ? safeJson(text) : null;
  if (!res.ok) {
    const message = (data && typeof data === 'object' && 'error' in data && typeof data.error === 'string') ? data.error : res.statusText;
    throw new ApiError(res.status, message, data && typeof data === 'object' && 'details' in data ? data.details : undefined);
  }
  return data as T;
}

function safeJson(text: string): unknown { try { return JSON.parse(text); } catch { return text; } }

/** Company-scoped call: /api/companies/:id + path */
export function capi<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  if (!currentCompanyId) return Promise.reject(new ApiError(400, 'No company selected'));
  return api<T>(`/api/companies/${currentCompanyId}${path}`, init);
}

export function companyUrl(path: string) { return `/api/companies/${currentCompanyId}${path}`; }
